export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "de-DE",
    "Messages": {
        "Administracja": "Verwaltung",
        "Aktywny": "Aktiv",
        "Anuluj": "Abbrechen",
        "Brak pasujących dokumentów": "Keine passenden Dokumente",
        "Brak pasujących stron": "Keine passenden Seiten",
        "Data dodania": "Hinzufügedatum",
        "Data indeksowania": "Indexierungsdatum",
        "Data modyfikacji": "Änderungsdatum",
        "Dodaj słowo": "Wort hinzufügen",
        "Dodaj synonim": "Synonym hinzufügen",
        "Dodaj synonimy": "Synonyme hinzufügen",
        "Dokument": "Dokument",
        "Dokumenty": "Dokumente",
        "Edytuj": "Bearbeiten",
        "Embeddings": "Embeddings",
        "Endpoint listy indeksów nie jest dostępny. Wdróż aktualną wersję API.": "Der Endpunkt für die Indexliste ist nicht verfügbar. Stellen Sie die aktuelle API-Version bereit.",
        "Health": "Gesundheitsstatus",
        "ID": "ID",
        "ID dokumentu": "Dokument-ID",
        "ID encji": "Entitäts-ID",
        "Indeks": "Index",
        "Lista indeksów": "Indexliste",
        "Mappingi": "Mappings",
        "Nie dotyczy": "Nicht zutreffend",
        "Nie znaleziono dokumentu.": "Dokument nicht gefunden.",
        "Otwarty": "Offen",
        "Partycja": "Partition",
        "Podaj ID dokumentu i kliknij „Szukaj”, aby pobrać jego zawartość.": "Geben Sie die Dokument-ID ein und klicken Sie auf „Suchen“, um den Inhalt abzurufen.",
        "Podgląd indeksu": "Indexvorschau",
        "Potwierdzenie usunięcia": "Löschbestätigung",
        "Przebudowanie indeksów": "Indizes neu erstellen",
        "Przebudowanie indeksów\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od rozmiaru indeksów.\n\nNależy używać tylko w przypadku konieczności zaaplikowania zmian dokonanych w słownikach synonimów lub słów wykluczonych.": "Indizes neu erstellen\n\nDer Vorgang kann je nach Größe der Indizes einige Sekunden bis mehrere Stunden dauern.\n\nVerwenden Sie diese Funktion nur, wenn Änderungen an den Wörterbüchern für Synonyme oder ausgeschlossene Wörter angewendet werden müssen.",
        "Przeindeksowanie danych": "Daten neu indexieren",
        "Przeindeksowanie danych\n\nOperacja może trwać od kilku sekund do kilku godzin w zależności od ilości danych w bazie.\n\nNależy używać tylko w przypadku zauważenia braku danych w indeksach.": "Daten neu indexieren\n\nDer Vorgang kann je nach Datenmenge in der Datenbank einige Sekunden bis mehrere Stunden dauern.\n\nVerwenden Sie diese Funktion nur, wenn Daten in den Indizes fehlen.",
        "Rozmiar": "Größe",
        "Słowa wykluczone": "Ausgeschlossene Wörter",
        "Słowo": "Wort",
        "Słowo wykluczone": "Ausgeschlossenes Wort",
        "Słowo zostało dodane.": "Das Wort wurde hinzugefügt.",
        "Słowo zostało usunięte.": "Das Wort wurde gelöscht.",
        "Słowo zostało zaktualizowane.": "Das Wort wurde aktualisiert.",
        "Spróbuj wpisać inną nazwę strony.": "Versuchen Sie, einen anderen Seitennamen einzugeben.",
        "Status": "Status",
        "Statusy": "Statuswerte",
        "Strony": "Seiten",
        "Synonimy": "Synonyme",
        "Synonimy zostały dodane.": "Die Synonyme wurden hinzugefügt.",
        "Synonimy zostały usunięte.": "Die Synonyme wurden gelöscht.",
        "Synonimy zostały zaktualizowane.": "Die Synonyme wurden aktualisiert.",
        "System": "System",
        "Szczegóły": "Details",
        "Szczegóły dokumentu": "Dokumentdetails",
        "Szkic": "Entwurf",
        "Szukaj": "Suchen",
        "Szukane słowo": "Suchbegriff",
        "Typ encji": "Entitätstyp",
        "Tytuł": "Titel",
        "Ustawienia": "Einstellungen",
        "Usuń": "Löschen",
        "Usunięty": "Gelöscht",
        "Wpisz jedno słowo, które wyszukiwarka ma pomijać, np. „i” lub „oraz”. Każde słowo dodaj jako osobny wpis.": "Geben Sie ein Wort ein, das die Suchmaschine ignorieren soll, z. B. „und“ oder „sowie“. Fügen Sie jedes Wort als separaten Eintrag hinzu.",
        "Wpisz każdy synonim w osobnym polu. Kliknij „Dodaj synonim”, aby dodać kolejne określenie.": "Geben Sie jedes Synonym in ein separates Feld ein. Klicken Sie auf „Synonym hinzufügen“, um eine weitere Bezeichnung hinzuzufügen.",
        "Wpisz słowo główne, do którego chcesz przypisać alternatywne określenia używane przy wyszukiwaniu.": "Geben Sie das Hauptwort ein, dem Sie alternative Bezeichnungen zuordnen möchten, die bei der Suche verwendet werden.",
        "Wyszukiwanie": "Suche",
        "Zaakceptowany": "Akzeptiert",
        "Zadanie przebudowania indeksów zostało rozpoczęte.": "Die Aufgabe zum Neuerstellen der Indizes wurde gestartet.",
        "Zadanie przeindeksowania danych zostało rozpoczęte.": "Die Aufgabe zum Neuindexieren der Daten wurde gestartet.",
        "Zakończony": "Abgeschlossen",
        "Zamknij": "Schließen",
        "Zapisz": "Speichern",
        "Zmiany zaczną obowiązywać dopiero po przebudowaniu indeksów.": "Die Änderungen werden erst nach dem Neuerstellen der Indizes wirksam.",
        "Zmień filtry lub wpisz inną frazę.": "Ändern Sie die Filter oder geben Sie einen anderen Suchbegriff ein."
    }
};
